import { Button } from '@/components/ui/button';
import { ArrowRight } from '@phosphor-icons/react';

export const CtaSection = ({ onGetStarted }) => {
  return (
    <section className="py-24 px-6 bg-[#09090B]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-white mb-6">
          Ready to Level Up?
        </h2>
        <p className="text-lg text-white/70 mb-10">
          Play, chat and squad up with gamers worldwide. It&apos;s free — start your journey today.
        </p>
        <Button 
          size="lg"
          onClick={onGetStarted}
          className="bg-[#0047FF] hover:bg-[#0037CC] text-white text-lg px-10 py-6"
          data-testid="cta-get-started"
        >
          Get Started Free
          <ArrowRight size={20} className="ml-2" />
        </Button>
      </div>
    </section>
  );
};
